<template>
    <div class="chart-font">
        <div class="row">
            <div class="col title text-muted">{{ title }}</div>
            <div class="col-md-auto"><a :href="hrefMore">More...</a></div>
        </div>
        <div v-if="documents.length" class="table-responsive">
            <table class="table table-sm">
                <thead>
                    <th>Patient</th>
                    <th v-if="showCMSColumn">PAN</th>
                    <th v-if="showCMSColumn">DOS</th>
                    <th>Description</th>
                    <th v-if="showClient">Client</th>                    
                    <th>Created</th>
                </thead>
                <tbody>
                    <tr v-for="document in documents" :key="'new-documents-chart-' + document.id">
                        <td><a :href="document.claim_href" class="px-1" :title="document.patient_name">{{ document.patient_name | truncate(25) }}</a></td>
                        <td v-if="showCMSColumn">
                            <a :href="document.services_href">{{ document.pan }}</a>
                        </td>
                        <td v-if="showCMSColumn">
                            <a :href="document.services_href">{{ document.dos }}</a>
                        </td>
                        <td :title="document.description">                        
                            <a :href="document.href" target="_blank">{{ document.description | truncate(25) }}</a>
                        </td>
                        <td v-if="showClient">{{ document.client_name | truncate(25) }}</td>
                        <td>{{ document.created_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else class="border-top pt-2">
            <h5 class="text-muted text-center">No {{ title }}.</h5>
        </div> 
    </div>    
</template>

<script>
import { DocumentType } from '../../constants.js';

export default {
    props: {
        title: String,
        href: String
    },
    data() {
        return {
            documents: [],
            documentType: null,
            hrefMore: '#',

            DocumentType: DocumentType          
        }
    },
    computed: {
        showClient: function () {
            return [...new Set(this.documents.map(document => document.client_name))].length > 1;
        },
        showCMSColumn: function () {
            return [DocumentType.CMS_1500, DocumentType.CMS_1450].includes(this.documentType.id);
        }
    },    
    methods: {
        refresh: function () {

            axios.get(this.href)
                .then(response => {
                    this.documentType = response.data.document_type;
                    this.documents = response.data.documents;
                    this.hrefMore = response.data.href;
                });
        }
    },
    created() {
        this.refresh();

        // TODO: listen for events
    }
}
</script>

<style scoped>
    .chart-font {
        font-size: 12px;
        font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
        font-style: normal;
        font-weight: bold;
        color: #666;
    } 
</style>